<template>
  <div>
    <filters-bar
    title="Carga diaria"
    title-class="headline"
    :filters="filters"
    :has-date-type="false"
    :filters-button="false"
    @search="search">
    </filters-bar>
    <v-layout row wrap justify-center>
      <template v-for="(info, i) in data">
        <v-flex
          :ml-3="i === 0"
          class="card-pie"
          :key="`card-${i}`"
          pr-3
          @click="showModal(i + 1)">
          <v-card ripple hover>
            <v-card-title primary-title class="text-xs-center pb-0">
              <v-layout row wrap>
                <v-flex xs12 class="text-center">
                  <v-icon small>
                    {{ info.icon }}
                  </v-icon>
                </v-flex>
                <v-flex xs12>
                  <p class="subheading">
                    {{ info.title }}
                  </p>
                </v-flex>
                <v-flex xs12>
                  <p class="body-2">
                    {{ Intl.NumberFormat('es-VE').format(info.total) }}
                  </p>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex :key="`icon-${i}`" v-if="(i + 1) < data.length" class="arrowNext">
          <v-icon>
            fas fa-angle-right
          </v-icon>
        </v-flex>
      </template>
    </v-layout>
    <info-modal :filters="filters" :id="id" :show="dialog" @close="dialog = false"/>
  </div>
</template>

<script>
import FiltersBar from '@/components/global/FiltersBar';
import moment from 'moment';
import InfoModal from './InfoModal';

export default {
  components: {
    InfoModal,
    FiltersBar,
  },
  mounted() {
    this.search();
  },
  data() {
    return {
      dialog: false,
      id: 0,
      filters: {
        date: moment().format('YYYY-MM-DD'),
        dateType: 'date',
      },
      data: [
        {
          icon: 'fas fa-file-alt',
          title: 'Archivo de Lectura',
          total: 0,
        },
        {
          icon: 'fas fa-file-signature',
          title: 'Antes de filtros',
          total: 0,
        },
        {
          icon: 'fas fa-filter',
          title: 'Despues de filtros',
          total: 0,
        },
        {
          icon: 'fas fa-database',
          title: 'Cargados',
          total: 0,
        },
      ],
    };
  },
  methods: {
    showModal(id) {
      this.id = id;
      this.dialog = true;
    },
    search(filters = { date: moment().format('YYYY-MM-DD') }) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
      this.axios.get('daily_load/report', {
        params: {
          ...this.filters,
        },
      }).then((res) => {
        for (let i = 0; i < this.data.length; i += 1) {
          this.data[i].total = (res.data.stages.find(x => x.type_id === (i + 1))
            || {}).total || 0;
        }
      });
    },
  },
};
</script>
<style scoped>
  .arrowNext {
    margin-top: auto;
    margin-bottom: auto;
  }
  .card-pie{
    -ms-flex-preferred-size: 22%;
    flex-basis: 22%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 22%;
  }
</style>




// WEBPACK FOOTER //
// src/components/panel/daily_load/DailyLoad.vue